<a class="btn btn-success large-calculate-btn" rel="nofollow" [class.loading]="loadingProduct" [routerLink]="gotoLink" (click)="loadingProduct = true">
    <span>{{ 'SHARED.CALCULATE' | translate | uppercase }} {{ productName }}</span>
</a>
